import { Box, Typography } from '@mui/material';
import { RegisterSessionEnum } from '@schooly/api';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface AmPmDividerProps {
  session: RegisterSessionEnum;
}

export const AmPmDivider: FC<AmPmDividerProps> = ({ session }) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      sx={{
        position: 'absolute',
        height: 0,
        left: 0,
        right: 0,
        transform: 'translateY(-1px)',
      }}
    >
      <Box
        sx={(theme) => ({
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          borderTop: `1px solid ${theme.palette.common.dijon1}`,
        })}
      />
      <Typography
        sx={(theme) => ({
          position: 'absolute',
          left: 0,
          top: theme.spacing(-2.15 / 2),
          textAlign: 'center',
          width: theme.spacing(4),
          borderRadius: theme.spacing(3),
          border: `1px solid ${theme.palette.common.dijon1}`,
          color: 'primary.main',
          backgroundColor: theme.palette.background.paper,
          lineHeight: theme.spacing(2.15),
        })}
      >
        {formatMessage({ id: `school-timetableStructure-registerSession-badge-${session}` })}
      </Typography>
    </Box>
  );
};
